"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var client_lib_js_player_addons_common_player_1 = require("@sky-uk-ott/client-lib-js-player-addons-common-player");
var BrowserNetworkStatus = (function (_super) {
    __extends(BrowserNetworkStatus, _super);
    function BrowserNetworkStatus(window) {
        var _this = _super.call(this) || this;
        _this.window = window;
        _this.window.addEventListener('online', _this.handleConnected.bind(_this));
        _this.window.addEventListener('offline', _this.handleDisconnected.bind(_this));
        return _this;
    }
    BrowserNetworkStatus.prototype.isConnected = function () {
        return this.window.navigator.onLine;
    };
    BrowserNetworkStatus.prototype.handleConnected = function () {
        this.notifyStatusChange(client_lib_js_player_addons_common_player_1.ConnectionStatus.Connected);
    };
    BrowserNetworkStatus.prototype.handleDisconnected = function () {
        this.notifyStatusChange(client_lib_js_player_addons_common_player_1.ConnectionStatus.Disconnected);
    };
    return BrowserNetworkStatus;
}(client_lib_js_player_addons_common_player_1.NetworkStatus));
exports.BrowserNetworkStatus = BrowserNetworkStatus;
